import { Chip, Typography, Box, Card, Stack } from "@mui/material";
import {
  spacing,
  colors,
  typography,
} from "../../../../../../../../../assets/styles/tokens";
import RevenueStreamsTable from "./RevenueStreamsTable";
import type { RevenueRow } from "./RevenueStreamsTable";

const TotalIncomeTableHeadings = {
  metric: "",
  actual_target: "Actual / Target",
  RR: "RR",
  PRR: "PRR",
};

const TotalIncomeTableRows: RevenueRow[] = [
  {
    cron_id: "1",
    rrType: "success",
    metric: "CPA",
    actual_target: "$1,614,441 / $1,239,322",
    RR: "$375,119",
    PRR: "130.3%",
  },
  {
    cron_id: "2",
    rrType: "warning",
    metric: "RS",
    actual_target: "$394 / $399",
    RR: "-$5",
    PRR: "98.6%",
  },
];

export default function RevenueStreams() {
  return (
    <Card
      sx={{
        p: spacing.Spacing.lg.$value,
        borderRadius: spacing.Radius.xl.$value,
        boxShadow:
          "0px 1px 2px rgba(16,24,40,0.06), 0px 1px 3px rgba(16,24,40,0.1)",
      }}
    >
      {/* HEADER */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-end"
        mb={2}
      >
        <Box>
          <Typography
            sx={{
              fontSize: typography.Size.Text.sm.$value,
              fontWeight: 500,
              color: colors.GrayLightMode[600].$value,
            }}
          >
            TOTAL INCOME
          </Typography>

          <Typography
            sx={{
              fontSize: typography.Size.Text.xl.$value,
              fontWeight: 600,
              color: colors.GrayLightMode[900].$value,
              mt: spacing.Spacing.xs.$value,
            }}
          >
            $1,093,140
          </Typography>

          <Typography
            sx={{
              fontSize: typography.Size.Text.sm.$value,
              color: colors.GrayLightMode[600].$value,
              mt: spacing.Spacing.xxs.$value,
            }}
          >
            out of{" "}
            <Box
              component="span"
              fontWeight={600}
              color={colors.GrayLightMode[900].$value}
            >
              $1,478,063
            </Box>
          </Typography>
        </Box>

        <Stack spacing={spacing.Spacing.sm.$value} alignItems="flex-end">
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography color={colors.GrayLightMode[700].$value}>RR</Typography>
            <Chip
              label="105.65%"
              sx={{
                bgcolor: colors.Success[50].$value,
                color: colors.Success[700].$value,
                fontWeight: 600,
                borderRadius: spacing.Radius.sm.$value,
              }}
            />
          </Stack>

          <Stack direction="row" spacing={1} alignItems="center">
            <Typography color={colors.GrayLightMode[600].$value}>
              PRR
            </Typography>
            <Typography
              fontWeight={600}
              color={colors.GrayLightMode[900].$value}
            >
              $1,561,629
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      {/* TABLE */}
      <RevenueStreamsTable
        TotalIncomeTableHeadings={TotalIncomeTableHeadings}
        TotalIncomeTableRows={TotalIncomeTableRows}
      />
    </Card>
  );
}
